// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NetworkFeesModal_wrapper__3lw1o","content":"NetworkFeesModal_content__3QaLn","feesInfo":"NetworkFeesModal_feesInfo__SUY-U","error":"NetworkFeesModal_error__13Svj"};